import { useMatch, useNavigate } from 'react-router-dom';
import { Button, IconLucide } from '@yakit/ui-components';

export const VDLBannerBackButton = () => {
  const match = useMatch(':level0Code/*');
  const navigate = useNavigate();

  const handleBack = () => {
    if (match) {
      navigate('/');
    } else {
      window.location.href = 'https://sc.sakha.gov.ru/sc/profnew/sp';
    }
  };

  if (!match) return null;

  return (
    <>
      <Button
        className="shrink-0"
        variant="glass"
        size="rounded-icon"
        onClick={handleBack}
      >
        <IconLucide name="ChevronLeft" className="h-4 w-4" />
      </Button>
      <span className="text-primary-foreground line-clamp-1 truncate text-lg">
        {match
          ? 'Показатели оценки эффективности деятельности высших должностных лиц'
          : 'Подсистема стратегического планирования'}
      </span>
    </>
  );
};
